import {
    FETCH_CITIES_BY_PROVINCES_ID_SUCCESS,
    FETCH_COUNTRIES_BY_ID_SUCCESS,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS,
    FETCH_PROVINCES_BY_ID_SUCCESS,
    FETCH_CITIES_BY_ID_SUCCESS,

    LOCATION_REQUEST_LOADING,
    LOCATION_REQUEST_ERRORS,
    CLEAR_ALL_LOCATIONS
} from "actions/locations/actions";

const initialState = {
    loading: false,
    errors: [],

    countries: [],
    provinces: [],
    cities: [],

    currentCountry: {},
    currentProvince: {},
    currentCity: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOCATION_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case LOCATION_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload.content
            };
        case FETCH_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.payload.content,
                loading: false,
                errors: [],
            };
        case FETCH_COUNTRIES_BY_ID_SUCCESS:
            return {
                ...state,
                currentCountry: action.payload.content,
                loading: false,
                errors: [],
            };
        case FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS:
            return {
                ...state,
                provinces: action.payload.content,
                loading: false,
                errors: [],
            };
        case FETCH_PROVINCES_BY_ID_SUCCESS:
            return {
                ...state,
                currentProvince: action.payload.content,
                loading: false,
                errors: [],
            };
        case FETCH_CITIES_BY_PROVINCES_ID_SUCCESS:
            return {
                ...state,
                cities: action.payload.content,
                loading: false,
                errors: [],
            };
        case FETCH_CITIES_BY_ID_SUCCESS:
            return {
                ...state,
                currentCity: action.payload.content,
                loading: false,
                errors: [],
            };
        case CLEAR_ALL_LOCATIONS:
            return {
                loading: false,
                errors: [],

                countries: [],
                provinces: [],
                cities: [],

                currentCountry: {},
                currentProvince: {},
                currentCity: {},
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/locations.js